import { BookingSource } from '@/constants';
import { formatPriceWithCurrency } from '@/hooks/useCurrencyFormat';
import moment from 'moment';
import React from 'react';

type Props = {
  faCancelChargeDate: any;
  price: number | undefined | null;
  cancelledAt: any;
  source: number | any;
  currency: string | undefined;
};

export default function PriceOrTBA({ faCancelChargeDate, price, source, cancelledAt, currency }: Props) {
  const isTBAPrice = React.useMemo(() => {
    if (cancelledAt && source === BookingSource.ForAgent && !price) {
      return !moment(cancelledAt)
        .tz('Asia/Tokyo')
        .isBefore(moment(faCancelChargeDate).startOf('D'));
    }
    return false;
  }, [faCancelChargeDate, price, source, cancelledAt]);
  return isTBAPrice ? <b style={{ color: 'red' }}>TBA</b> : <b>{formatPriceWithCurrency(price, currency)}</b>;
}
